export default ({ request }) => ({
  finPaymentNoInvoiceListApi(data = {}) {
    return request({
      url: '/financial/fin/payment/noInvoice/list',
      method: 'POST',
      data,
    })
  },
  finPaymentNoInvoiceDetailApi(data = {}) {
    return request({
      url: '/financial/fin/payment/noInvoice/detail',
      method: 'POST',
      data,
    })
  },
  finPaymentNoInvoiceNotifyEmailApi(data = {}) {
    return request({
      url: '/financial/fin/payment/noInvoice/notify/email',
      method: 'POST',
      data,
    })
  },
  finPaymentNoInvoiceReceivedApi(data = {}) {
    return request({
      url: '/financial/fin/payment/noInvoice/invoice/received',
      method: 'POST',
      data,
    })
  },
})
